import { useEffect } from 'react'
import {getListPolinomyTypes} from '../../../services/sKPI/polinomyType.service'


const useGetPolinomyTypesMaintainer = (mantainerList, setMantainer) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListPolinomyTypes();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({id: element.id , name: element.name, description: element.description, typeOfCode: element.typeOfCode, typeOfNemo: ""})
                });

                setMantainer(aux_array);
            }
            catch (error) {
                setMantainer([])
            }
        }
        
        if (mantainerList === null) {
            getData()
        }
    }, [mantainerList, setMantainer]);
}

const useGetPolinomyTypes = (contracts, setContracts) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListPolinomyTypes();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({
                        key: element.id,
                        text: `${element.name}`,
                        title:  `${element.name}`})
                });

                setContracts(aux_array);
            }
            catch (error) {
                setContracts([]);
            }
        }
        
        if (contracts === null) {
            getData()
        }
    }, [contracts, setContracts]);
}

export {
    useGetPolinomyTypesMaintainer,
    useGetPolinomyTypes
}